import styled from 'styled-components';

export const Link = styled.a`
    color: ${props => props.color ? props.color : '#000'};

    &:hover {
        color: ${props => props.color ? props.color : '#000'};
    }
`
